import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Lottie from "lottie-react";
import techAnimation from "../../Assets/TechnologyIsometricAiRobotBrain.json";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { Helmet } from "react-helmet";

function Home() {
  return (
    <>
      <Helmet>
        <title>Thássio Silva | Home</title>
        <meta
          name="description"
          content="Robotics and software engineer building ML-powered autonomy, embedded systems, and cutting-edge R&D projects."
        />
      </Helmet>
      <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> THÁSSIO SILVA</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <Lottie
                animationData={techAnimation}
                loop={true}
                className="img-fluid home-anim"
                style={{ maxHeight: "450px", marginTop: "-38px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
      </section>
    </>
  );
}

export default Home;
